<div
    [ngClass]="[
        'search-form',
        responsive.screenSize,
        responsive.isWebPortrait() ? '' : page,
    ]"
>
    <div class="selects-container">
        <app-select-dropdown
            class="select-container"
            noneSelectName="Category"
            [items]="categoryList"
            (onSelectChange)="onCategoryListChange($event)"
        />
        <app-select-dropdown
            class="select-container"
            noneSelectName="Channel group"
            [items]="filteredGroupList"
            (onSelectChange)="onGropListChange($event)"
        />
    </div>

    <div>
        <app-edit-page-search-dropdown
            class="edit-page-search-dropdown-container"
            subTitle="Search Channel Name or Number"
            placeholder="Search Channel Name or Number"
            (onValueChange)="searchInputChannel($event)"
            [maxlength]="50"
        />
    </div>
</div>

<div
    [ngClass]="['selected-groups', responsive.screenSize]"
    *ngIf="selectedGroups.length"
>
    <div *ngFor="let item of selectedGroups" class="selected-group">
        <p data-cy="channel-group-filter-badge">
            {{ "Channel group : " + item.name }}
        </p>
        <mat-icon
            data-cy="channel-group-filter-badge-x-icon"
            class="close-icon"
            (click)="unselectGroup(item)"
            >clear</mat-icon
        >
    </div>
</div>

<div
    *ngIf="
        selectedCategories.length == 0 &&
        selectedGroups.length == 0 &&
        !inputChannel
    "
>
    <span data-cy="channel-search-info-text" class="help-description">{{
        "labels.channel.not-found-message" | translate
    }}</span>
</div>

<div
    *ngIf="shouldDisplayGraphPreviewIcon()"
    class="preview-icon-container"
    (click)="onShowPreviewEmit()"
>
    <mat-icon svgIcon="preview" />
    <div>
        {{ previewLabel.concat(".", page) | translate }}
    </div>
</div>

<!--Table -->
<div
    *ngIf="filteredChannelList.length > 0"
    [ngClass]="{ paddingTop: selectedGroups.length == 0 }"
>
    <table mat-table [dataSource]="dataSource" class="table">
        <ng-container matColumnDef="Ch. Group">
            <th
                data-cy="ch-group-label"
                mat-header-cell
                *matHeaderCellDef
                class="table-header"
            >
                {{ "labels.channel.group" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-row">
                {{ checkGroupName(element.groupId) }}
            </td>
        </ng-container>

        <ng-container matColumnDef="Ch. No.">
            <th
                data-cy="ch-no-label"
                mat-header-cell
                *matHeaderCellDef
                class="table-header"
            >
                {{ "labels.channel.number" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-row">
                {{ element.opsData.tag }}
            </td>
        </ng-container>

        <ng-container matColumnDef="Ch. Name">
            <th
                data-cy="ch-name-label"
                mat-header-cell
                *matHeaderCellDef
                class="table-header"
            >
                {{ "labels.channel.name" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-row">
                {{ element.opsData.name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="Category">
            <th
                data-cy="category-label"
                mat-header-cell
                *matHeaderCellDef
                class="table-header"
            >
                {{ "labels.channel.category" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-row">
                {{ element.opsData.channelType }}
            </td>
        </ng-container>

        <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef class="table-header"></th>
            <td mat-cell *matCellDef="let element" class="table-row">
                <mat-checkbox
                    [(ngModel)]="element.checked"
                    (click)="
                        $event.stopPropagation(); checkChannel(element, true)
                    "
                >
                </mat-checkbox>
            </td>
        </ng-container>
        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="table-header"
        ></tr>
        <tr
            data-cy="channel-list-row"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="checkChannel(row, false)"
            [ngClass]="{ selected: row.checked }"
        ></tr>
    </table>
</div>
<app-page-list
    style="margin: 36px 0px; display: block"
    *ngIf="paginator"
    #pageList
    [pages]="numberOfPages"
    [displayedPageLimit]="displayedPageLimit"
    (onPageSelected)="calculateDisplayData($event)"
>
</app-page-list>
